import React from 'react';
import SidebarMenu from '../sidebar/Sidebar';
import './AppLayout.css';
import { useSidebar } from '../../context/SidebarContext';

const AppLayout = ({ children }) => {

  const { collapsed } = useSidebar();
  
  return (
    <div className="app-layout">
      <SidebarMenu />
      <main
        className="app-layout-content"
        style={{
          marginLeft: collapsed ? '80px' : '250px',
          transition: 'margin-left 0.3s ease-in-out',
        }}
      >
        {children}
      </main>
    </div>
  );
};

export default AppLayout;
